export default "__VITE_ASSET__CN_3bjN8__"